export default __webpack_public_path__ + "static/media/mac.ecdcdcbd.png";